module.exports = __webpack_public_path__ + "static/img/course02.127b251.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course02.jpg
// module id = /mIO
// module chunks = 101